import EditSlotForm from './EditSlotForm';

export default EditSlotForm;
